import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'om-auto-renewal-opt-in',
  templateUrl: './auto-renewal-opt-in.component.html',
  styleUrls: ['./auto-renewal-opt-in.component.scss', '../inline-editable.scss'],
})
export class AutoRenewalOptInComponent {
  @Input() showError: boolean;
  @Output() checked = new EventEmitter<boolean>();

  consentText = 'I agree to the recurring charges using the chosen payment method (required)';
  inlineErrorText = 'To continue, check the box to agree';
}
